import {
  LookbookItemResponseDto,
  LookbookResponseDto,
  ProductListResponseDto,
} from '@epicuro-next/data/engagement/engagement-models';

export function extractLookbookUniqueLists(lookBooks: LookbookResponseDto[]) {
  const lookBookProductLists = lookBooks.reduce((acc, { items }) => {
    const lists = extractProductListsFromItems(items);
    return [...acc, ...lists];
  }, [] as ProductListResponseDto[]);

  return [
    ...new Map(lookBookProductLists.map((item) => [item.id, item])).values(),
  ];
}

export function extractProductListsFromItems(items: LookbookItemResponseDto[]) {
  return items.map(({ productList }) => productList);
}
